module.exports = __webpack_public_path__ + "static/media/iconeComanda.d00e032d.svg";